import React, { Fragment, useRef, useState } from "react";
import "./Toggle.css";
import CompnayToggle from "./CompnayToggle";
import GroupsTableData from "./GroupsTableData";
import CompnayStaffTableData from "./CompanyStaffTableData";
import { Dialog, Transition } from "@headlessui/react";
import { ExclamationIcon } from "@heroicons/react/outline";
import { useNavigate } from "react-router-dom";
import {getAuthorization} from "../../../axios/AxiosAut";
import { Formik, Form, Field } from "formik";
import Swal from "sweetalert2";
import "animate.css";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { setAPIDetailsGroupTable } from "../../../redux/slices/statistics/statisticSlice";

const MemberValidationSchema = Yup.object({
  email: Yup.string().email("Invalid Email").required("Email Required"),
  job_role: Yup.string()
    .min(2, "Too short!")
    .max(20, "Too long!")
    .required("Required"),
});

const GroupValidationSchema = Yup.object({
  group_name: Yup.string()
    .min(2, "Too short!")
    .max(20, "Too long!")
    .required("Required"),
  group_description: Yup.string()
    .min(2, "Too short!")
    .max(40, "Too long!")
    .required("Required"),
});

function CompanyStaff() {
  const [Toggle, setToggle] = useState("Staff");
  const [open, setOpen] = useState(false);
  const [AddGroup, setAddGroup] = useState(false);
  const Permissions = useSelector((state) => state.user.userPermissions);
  const addmember = Permissions.find((o) => o.codename === "add_staff");
  const addgroup = Permissions.find((o) => o.codename === "add_customgroups");

  const AddMemberInitialValues = {
    email: "",
    job_role: "",
    redirect_url: "http://localhost:3000/login",
  };
  const CreateGroupInitialValues = {
    group_name: "",
    group_description: "",
  };
  const toggleHandler = () => {
    if (Toggle == "Groups") {
      setToggle("Staff");
    } else {
      setToggle("Groups");
    }
  };
  const MemberModalHandler = () => {
    setOpen(true);
    setAddGroup(false);
  };
  const GroupModelHandler = () => {
    setOpen(true);
    setAddGroup(true);
  };

  const ShowMemberNotification = () => {
    Swal.fire({
      position: "top-end",
      title: "Invitation Sent!",
      showConfirmButton: false,
      timer: 3500,
      showClass: {
        popup: "animate__animated animate__fadeInRight",
      },
      hideClass: {
        popup: "animate__animated animate__fadeOutRight",
      },
      width: 300,
      color: "#FFFFFF",
      background: "#2A91D7",
      backdrop: `rgba(0,0,0,0)`,
    });
  };
  const ShowGroupNotification = () => {
    Swal.fire({
      position: "top-end",
      title: "Group Added!",
      showConfirmButton: false,
      timer: 3500,
      showClass: {
        popup: "animate__animated animate__fadeInRight",
      },
      hideClass: {
        popup: "animate__animated animate__fadeOutRight",
      },
      width: 300,
      color: "#FFFFFF",
      background: "#2A91D7",
      backdrop: `rgba(0,0,0,0)`,
    });
  };
  const HandleSubmitAddMember = (values, onSubmitProps) => {
    getAuthorization()
      .post("company/send_staff_invite/", values)
      .then((res) => {
        console.log("values", values);
        setOpen(false);
        onSubmitProps.setSubmitting(false);
        setTimeout(() => {
          ShowMemberNotification();
        }, 1000);
      })
      .catch((err) => {
        console.log("Error in adding member", err);
        onSubmitProps.setSubmitting(false);
      });
  };

  const APIDetailsGroupTable = useSelector(
    (state) => state.statistics.APIDetailsGroupTable
  );
  const dispatch = useDispatch();
  const getGroupdata = () => {
    getAuthorization()
      .get("company/all_groups/")
      .then((res) => {
        // setGroups(res.data.result);
        dispatch(setAPIDetailsGroupTable(res.data.result));
      })
      .catch((err) => {
        console.log("Error in getting company groups", err);
      });
  };
  const HandleSubmitCreateGroup = (values, onSubmitProps) => {
    getAuthorization()
      .post("company/group_create/", values)
      .then((res) => {
        console.log("values", values);
        setOpen(false);
        onSubmitProps.setSubmitting(false);
        setTimeout(() => {
          ShowGroupNotification();
        }, 1000);
        getGroupdata();
      })
      .catch((err) => {
        console.log("Error in creating group", err);
        onSubmitProps.setSubmitting(false);
      });
  };
  return (
    <>
      <div className="ml-8 container w-auto mb-7">
        <div className="flex flex-row justify-between w-full items-center">
          <div className="flex flex-row items-center">
            <div>
              <h2 className="font-Montserrat text-xl font-bold text-black">
                Company Staff
              </h2>
              <div className="border-b-2 border-blue-200 w-24"></div>
            </div>
            <div className="pl-2">
              <p className="font-Montserrat text-sm font-medium text-gray-100">
                9/20 Staff occupied
              </p>
            </div>
          </div>
          <div>
            {Toggle == "Staff" ? (
              !addmember ===undefined ||  addmember?.codename ===
              "add_staff" ? (
              <button
                type="button"
                onClick={MemberModalHandler}
                className="border-2 border-blue-200 hover:text-white text-base font-Montserrat font-bold text-blue-200 flex-shrink hover:border-blue-100 hover:bg-blue-100 place-content-center rounded-md px-2 py-1 flex flex-grow w-60 "
              >
                Add Member
              </button>
               ) : null
            ) : (
              !addgroup ===undefined ||  addgroup?.codename ===
              "add_customgroups" ? (
              <button
                type="button"
                onClick={GroupModelHandler}
                className="border-2 border-blue-200 hover:text-white text-base font-Montserrat font-bold text-blue-200 flex-shrink hover:border-blue-100 hover:bg-blue-100 place-content-center rounded-md px-2 py-1 flex flex-grow w-60 "
              >
                Add Group
              </button>
                 ) : null

            )}
          </div>
        </div>
        <CompnayToggle ToggleHandler={toggleHandler} Toggle={Toggle} />
      </div>
      {Toggle == "Staff" ? <CompnayStaffTableData /> : <GroupsTableData />}
      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="fixed z-10 inset-0 overflow-y-auto"
          onClose={setOpen}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-40 transition-opacity" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              {!AddGroup ? (
                <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                  <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                    <div className="sm:flex sm:items-start">
                      <div className="container w-auto">
                        <div className="w-full">
                          <Dialog.Title
                            as="h2"
                            className="font-Montserrat text-xl font-bold text-black"
                          >
                            Register User
                          </Dialog.Title>
                          <div className="border-b-2 border-blue-200 w-24"></div>
                        </div>
                      </div>
                    </div>
                    <Formik
                      initialValues={AddMemberInitialValues}
                      onSubmit={HandleSubmitAddMember}
                      validationSchema={MemberValidationSchema}
                      validateOnMount
                    >
                      <Form className="flex flex-col my-5 space-y-7">
                        <div className="flex flex-col">
                          <Field name="email">
                            {(props) => {
                              const { field, form, meta } = props;
                              return (
                                <>
                                  <div className="flex justify-center w-full">
                                    <input
                                      {...field}
                                      type="text"
                                      {...(meta.touched && meta.error
                                        ? {
                                            className:
                                              "border-b-2 relative block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                          }
                                        : {
                                            className:
                                              "border-b-2 relative block w-full px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                                          })}
                                      placeholder="Email ID"
                                    ></input>
                                  </div>
                                  {meta.touched && meta.error ? (
                                    <div className="flex pt-1">
                                      <label className="text-xs font-semibold font-Montserrat text-red-500">
                                        <span className="ml-1">
                                          {meta.error}
                                        </span>
                                      </label>
                                    </div>
                                  ) : null}
                                </>
                              );
                            }}
                          </Field>
                        </div>
                        <div className="flex flex-col">
                          <Field name="job_role">
                            {(props) => {
                              const { field, form, meta } = props;
                              return (
                                <>
                                  <div className="flex justify-center w-full">
                                    <input
                                      {...field}
                                      type="text"
                                      {...(meta.touched && meta.error
                                        ? {
                                            className:
                                              "border-b-2 relative block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                          }
                                        : {
                                            className:
                                              "border-b-2 relative block w-full px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                                          })}
                                      placeholder="Job Role"
                                    ></input>
                                  </div>
                                  {meta.touched && meta.error ? (
                                    <div className="flex pt-1">
                                      <label className="text-xs font-semibold font-Montserrat text-red-500">
                                        <span className="ml-1">
                                          {meta.error}
                                        </span>
                                      </label>
                                    </div>
                                  ) : null}
                                </>
                              );
                            }}
                          </Field>
                        </div>
                        <div className="flex justify-center w-full">
                          <Field>
                            {(props) => {
                              const { field, form, meta } = props;
                              const { isSubmitting } = form;
                              return (
                                <>
                                  {!isSubmitting ? (
                                    <button
                                      type="submit"
                                      {...(form.isValid
                                        ? {
                                            className:
                                              "font-Montserrat font-semibold text-white flex-shrink bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1 flex flex-grow",
                                          }
                                        : {
                                            disabled: true,
                                            className:
                                              "font-Montserrat font-semibold text-white flex-shrink bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1 flex flex-grow opacity-50 cursor-not-allowed",
                                          })}
                                    >
                                      Send Invitation
                                    </button>
                                  ) : (
                                    <button
                                      disabled
                                      className="font-Montserrat font-semibold text-white flex-shrink bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1 flex flex-grow "
                                    >
                                      <div className="flex items-center justify-center space-x-2 animate-pulse">
                                        <svg className="w-5 h-5 bg-green-50 rounded-full"></svg>
                                        <svg className="w-5 h-5 bg-green-50  rounded-full"></svg>
                                        <svg className="w-5 h-5 bg-green-50  rounded-full"></svg>
                                      </div>
                                    </button>
                                  )}
                                </>
                              );
                            }}
                          </Field>
                        </div>
                      </Form>
                    </Formik>
                  </div>
                </div>
              ) : (
                <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                  <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                    <div className="sm:flex sm:items-start">
                      <div className="container w-auto">
                        <div className="w-full">
                          <Dialog.Title
                            as="h2"
                            className="font-Montserrat text-xl font-bold text-black"
                          >
                            Create a new group
                          </Dialog.Title>
                          <div className="border-b-2 border-blue-200 w-24"></div>
                        </div>
                      </div>
                    </div>
                    <Formik
                      initialValues={CreateGroupInitialValues}
                      onSubmit={HandleSubmitCreateGroup}
                      validationSchema={GroupValidationSchema}
                      validateOnMount
                    >
                      <Form className="flex flex-col my-5 space-y-7">
                        <div className="flex flex-col">
                          <Field name="group_name">
                            {(props) => {
                              const { field, form, meta } = props;
                              return (
                                <>
                                  <div className="flex justify-center w-full">
                                    <input
                                      {...field}
                                      type="text"
                                      {...(meta.touched && meta.error
                                        ? {
                                            className:
                                              "border-b-2 relative block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                          }
                                        : {
                                            className:
                                              "border-b-2 relative block w-full px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                                          })}
                                      placeholder="Group Name"
                                    ></input>
                                  </div>
                                  {meta.touched && meta.error ? (
                                    <div className="flex pt-1">
                                      <label className="text-xs font-semibold font-Montserrat text-red-500">
                                        <span className="ml-1">
                                          {meta.error}
                                        </span>
                                      </label>
                                    </div>
                                  ) : null}
                                </>
                              );
                            }}
                          </Field>
                        </div>
                        <div className="flex flex-col">
                          <Field name="group_description">
                            {(props) => {
                              const { field, form, meta } = props;
                              return (
                                <>
                                  <div className="flex justify-center w-full">
                                    <input
                                      {...field}
                                      type="text"
                                      {...(meta.touched && meta.error
                                        ? {
                                            className:
                                              "border-b-2 relative block w-full px-2 border-red-500 placeholder-red-500 foucs: outline-none focus:border-red-600 transition-colors",
                                          }
                                        : {
                                            className:
                                              "border-b-2 relative block w-full px-2 border-gray placeholder-gray foucs: outline-none focus:border-blue-200 transition-colors",
                                          })}
                                      placeholder="Description"
                                    ></input>
                                  </div>
                                  {meta.touched && meta.error ? (
                                    <div className="flex pt-1">
                                      <label className="text-xs font-semibold font-Montserrat text-red-500">
                                        <span className="ml-1">
                                          {meta.error}
                                        </span>
                                      </label>
                                    </div>
                                  ) : null}
                                </>
                              );
                            }}
                          </Field>
                        </div>
                        <div className="flex justify-center w-full">
                          <Field>
                            {(props) => {
                              const { field, form, meta } = props;
                              const { isSubmitting } = form;
                              return (
                                <>
                                  {!isSubmitting ? (
                                    <button
                                      type="submit"
                                      {...(form.isValid
                                        ? {
                                            className:
                                              "font-Montserrat font-semibold text-white flex-shrink bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1 flex flex-grow",
                                          }
                                        : {
                                            disabled: true,
                                            className:
                                              "font-Montserrat font-semibold text-white flex-shrink bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1 flex flex-grow opacity-50 cursor-not-allowed",
                                          })}
                                    >
                                      Create Group
                                    </button>
                                  ) : (
                                    <button
                                      disabled
                                      className="font-Montserrat font-semibold text-white flex-shrink bg-green-100 hover:bg-green-200 place-content-center rounded-md py-1 flex flex-grow "
                                    >
                                      <div className="flex items-center justify-center space-x-2 animate-pulse">
                                        <svg className="w-5 h-5 bg-green-50 rounded-full"></svg>
                                        <svg className="w-5 h-5 bg-green-50  rounded-full"></svg>
                                        <svg className="w-5 h-5 bg-green-50  rounded-full"></svg>
                                      </div>
                                    </button>
                                  )}
                                </>
                              );
                            }}
                          </Field>
                        </div>
                      </Form>
                    </Formik>
                  </div>
                </div>
              )}
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
}

export default CompanyStaff;
